import Vue from "vue";
import moment from "moment";
import { bus } from "../../../../main";

import diagnosticDetail from "./detail/diagnostic-detail.vue";
import diagnosticChart from "./chart/diagnostic-chart.vue";

import helpers from "../../../../shared/fleetbox-helpers";

export default {
	components: {
		diagnosticDetail: diagnosticDetail,
		diagnosticChart: diagnosticChart
	},
	data: function() {
		return {
			//#region filters
			filters: [
				{
					id: "timerange",
					items: [],
					value: {
						period: "0",
						startRange: moment(),
						endRange: moment()
					}
				},
				{
					id: "divisions",
					items: [],
					value: []
				},
				{
					id: "groups",
					items: [],
					value: []
				},
				{
					id: "vehicles",
					items: [],
					value: []
				},
				{
					id: "drivers",
					items: [],
					value: []
				},
				{
					id: "diagnosis-type",
					items: [],
					value: {
						information: false,
						anomaly: true
					}
				}
			],
			//#endregion filters

			isChartLoading: false,
			isDetailLoading: false,

			reportName: ""
		};
	},

	created() {
		var self = this;
		//#region filters
		this.filters[0].value.startRange = moment()
			.add(-7, "days")
			.startOf("day");
		this.filters[0].value.endRange = moment().endOf("day");
		//#endregion filters

		bus.$emit("show-spinner-loading");

		helpers.getReportName().then(res => {
			if (res) {
				var report = res.find(item => {
					return item.id == 250;
				});

				if (report) {
					self.reportName = report.name;
				}
				else {
					self.reportName = "DIAGNOSI";
				}
			}
		});
	},
	mounted() {},

	watch: {
		isChartLoading: {
			handler: function() {
				this.loadingProgressUpdate();
			}
		},
		isDetailLoading: {
			handler: function() {
				this.loadingProgressUpdate();
			}
		}
	},

	methods: {
		//#region loading progress
		loadingProgressUpdate() {
			if (this.isChartLoading || this.isDetailLoading) {
				bus.$emit("show-spinner-loading");
			}
			else {
				bus.$emit("hide-spinner-loading");
			}
		},
		onDetailLoading(isLoading) {
			this.isDetailLoading = isLoading;
		},
		onChartLoading(isLoading) {
			this.isChartLoading = isLoading;
		},
		//#endregion
		//#region filters events
		onFilterApplyClick() {
			if (this.$refs.diagnosticDetailReport) {
				this.$refs.diagnosticDetailReport.applyReportFilter();
			}

			if (this.$refs.diagnosticChartReport) {
				this.$refs.diagnosticChartReport.applyReportFilter();
			}
		},
		onFilterResetClick() {
			this.setDefaultFilters();
			this.onFilterApplyClick();
		},
		onFilterDriverChange(newValue) {
			var driverFilter = this.filters.find(item => {
				return item.id == "drivers";
			});
			if (driverFilter) {
				Vue.set(driverFilter, "value", newValue);
			}
		},
		onFilterTimerangeChange(newValue) {
			var timeRangeFilter = this.filters.find(item => {
				return item.id == "timerange";
			});
			if (timeRangeFilter) {
				timeRangeFilter.value.startRange = moment(newValue.startDate);
				timeRangeFilter.value.endRange = moment(newValue.endDate);
			}
		},
		onFilterDivisionChange(newValue) {
			var divisionFilter = this.filters.find(item => {
				return item.id == "divisions";
			});
			if (divisionFilter) {
				Vue.set(divisionFilter, "value", newValue);
			}
		},
		onFilterGroupChange(newValue) {
			var groupFilter = this.filters.find(item => {
				return item.id == "groups";
			});
			if (groupFilter) {
				Vue.set(groupFilter, "value", newValue);
			}
		},
		onFilterPlateChange(newValue) {
			var vehiclesFilter = this.filters.find(item => {
				return item.id == "vehicles";
			});
			if (vehiclesFilter) {
				Vue.set(vehiclesFilter, "value", newValue);
			}
		},
		onDiagnosisTypeChange(newValue) {
			var diagnosisTypeFilter = this.filters.find(item => {
				return item.id == "diagnosis-type";
			});
			if (diagnosisTypeFilter) {
				Vue.set(diagnosisTypeFilter, "value", newValue);
			}
		},
		setDefaultFilters() {
			this.filters[0].value.period = "0";
			this.filters[0].value.startRange = moment()
				.add(-7, "days")
				.startOf("day");
			this.filters[0].value.endRange = moment().endOf("day");

			for (var i = 1; i < this.filters.length - 1; i++) {
				var flt = this.filters[i];

				Vue.set(flt, "value", []);
			}

			this.filters[5].value.information = false;
			this.filters[5].value.anomaly = true;
		}
		//#endregion filters events
	},
	computed: {}
};
